import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { FaChevronLeft, FaChevronDown } from "react-icons/fa";
import PatientAppointmentRequestCard from "./PatientAppointmentRequestCard";
import InputField from "./InputField";
import { IoMdSend } from "react-icons/io";
import { linearTopGradient, tuftsBlue } from "../constants/colors";
import { MdAttachFile, MdBrowseGallery, MdCamera, MdCameraAlt, MdImage, MdVideocam } from "react-icons/md";
import AppointmentTimeInfo from "../Pages/AppointmentSummary/comps/AppointmentTimeInfo";
import { db } from "../config/firebaseConfig";
import { collection, getDocs, query, orderBy, limit, onSnapshot, setDoc, doc, updateDoc } from "firebase/firestore";
import { getAppointmentChatCollection, setMessageToAppointmentChatCollection } from "../utils/firebaseChatUtils";
import { useSelector } from "react-redux";
import ChatMessageItem from "./ChatMessageItem";
import { getCurrentTimestamp, isDesktop } from "../utils/utils";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";
import { uploadFileGivePath } from "../utils/apiService";
import toast, { ToastIcon } from "react-hot-toast";
import axiosInstance from "../utils/axiosInstance";
import { getAgoraToken } from "../constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import DoctorDetailHeader from "./DoctorDetailHeader";

const ChatModal = ({ isOpen, appointment, onClose, isUser }) => {
  const loggedInUserData = useSelector((state) => state.appSlice.userData);
  const loggedInUDoctorData = useSelector((state) => state.appSlice.doctorData);
  const messagesEndRef = useRef(null);
  const imageUploadRef = useRef(null);
  const videoUploadRef = useRef(null);
  const [isAppointmentDetailExpanded, setIsAppointmentDetailExpanded] = useState(false);
  const toggleAppointmentExpanded = () => setIsAppointmentDetailExpanded(!isAppointmentDetailExpanded);
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [user, setUser] = useState("User1");

  const navigate = useNavigate();

  useBodyScrollLock(true);

  useEffect(() => {
    if (!appointment?.appointment_number) return;

    const chatRef = getAppointmentChatCollection(appointment.appointment_number);
    const q = query(chatRef, orderBy("id", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      let tempMessages = [];
      snapshot.forEach((doc) => {
        tempMessages.push(doc.data());
      });
      tempMessages.reverse();
      setMessages(tempMessages);
      console.log(tempMessages);
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    });

    return () => unsubscribe();
  }, [appointment?.appointment_number]);

  const getSenderUser = () => {
    let senderUser = {};
    if (loggedInUserData) {
      senderUser = {
        image: loggedInUserData.profile_image,
        dob: loggedInUserData.dob,
        name: loggedInUserData.fullname,
        identity: loggedInUserData.identity,
        userId: loggedInUserData.id,
      };
    } else {
      senderUser = {
        image: loggedInUDoctorData.image,
        dob: loggedInUDoctorData.dob,
        name: loggedInUDoctorData.name,
        identity: loggedInUDoctorData.identity,
        userId: loggedInUDoctorData.id,
      };
    }

    return senderUser;
  };

  const sendTextMessage = async (e) => {
    e.preventDefault();
    console.log(messageInput);
    if (messageInput.trim()) {
      const senderUser = getSenderUser();
      const timestamp = getCurrentTimestamp();
      console.log(loggedInUserData);
      const messageObject = {
        senderUser,
        videoCall: {
          isStarted: true,
          token: "",
          partientImage: "",
          channelId: appointment.appointment_number,
          patientName: appointment.patient ? appointment.patient.fullname : appointment.user.fullname,
          time: null,
        },
        video: null,
        id: timestamp,
        msgType: "text",
        msg: messageInput.trim(),
        image: null,
      };
      console.log(messageObject);
      await setMessageToAppointmentChatCollection(appointment.appointment_number.toString(), timestamp.toString(), messageObject);
      setMessageInput("");
    }
  };

  const fetchChatMessages = async () => {
    try {
      const chatRef = getAppointmentChatCollection(appointment.appointment_number);
      const q = query(chatRef, orderBy("id", "desc"), limit(20));
      const snapshot = await getDocs(chatRef);
      const tempMessages = [];
      snapshot.forEach((doc) => {
        tempMessages.push(doc.data());
      });
      setMessages(tempMessages);
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      console.log(tempMessages);
    } catch (error) {
      console.error("Error fetching chat messages:", error);
    }
  };

  async function openCamera() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      const videoElement = document.getElementById("camera");
      videoElement.srcObject = stream;
    } catch (err) {
      console.error("Error accessing camera:", err);
    }
  }

  const handleCameraPress = () => {
    openCamera();
  };
  const handleGalleryPress = () => {
    imageUploadRef.current?.click(); //
  };
  const handleRecordPress = () => {
    videoUploadRef.current?.click();
  };

  const onChooseFile = async (event, msgType) => {
    const file = event.target.files[0];
    if (!file) return;
    const uploadedFileResponse = await uploadFileGivePath(file);
    if (uploadedFileResponse.status) {
      const senderUser = getSenderUser();
      const timestamp = getCurrentTimestamp();
      console.log(loggedInUserData);
      const messageObject = {
        senderUser,
        videoCall: {
          isStarted: true,
          token: "",
          partientImage: "",
          channelId: appointment.appointment_number,
          patientName: appointment.patient ? appointment.patient.fullname : appointment.user.fullname,
          time: null,
        },
        video: msgType === "video" ? uploadedFileResponse.path : null,
        id: timestamp,
        msgType: msgType,
        msg: null,
        image: msgType === "image" ? uploadedFileResponse.path : null,
      };
      console.log(messageObject);
      await setMessageToAppointmentChatCollection(appointment.appointment_number.toString(), timestamp.toString(), messageObject);
    } else {
    }
  };

  const joinMeeting = async (message) => {
    const givenEpochTime = message.videoCall.time;
    const currentTimeInMs = Date.now();
    // if (currentTimeInMs > givenEpochTime) {
    const apiresponse = await axiosInstance.post(getAgoraToken, {
      channelName: appointment.appointment_number,
    });
    if (apiresponse.status === 200) {
      const videoCall = message.videoCall;
      videoCall.token = apiresponse.data.token;
      console.log(apiresponse.data);
      const chatRef = getAppointmentChatCollection(appointment.appointment_number);
      const docRef = doc(chatRef, message.id.toString());
      await updateDoc(docRef, videoCall);

      const data = {
        appointmentData: { ...appointment, videoCall: videoCall, message: message },
      };
      sessionStorage.setItem("videoCallData", JSON.stringify(data));
      window.open(
        "/start-video-call", // path or full URL
        "_self", // open in new tab (or use "_self" for same tab, "_windowName" for specific window)
        "width=800,height=600" // optional window features (only works if not using "_blank")
      );
      // await setMessageToAppointmentChatCollection(appointment.appointment_number.toString(), timestamp.toString(), messageObject);
    } else {
    }
    // } else {
    //   toast.error("Please wait your meeting not started yet.");
    // }
  };

  return (
    <ModalBackdrop onClick={() => onClose(false)}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <ModalHeader>
          <FaChevronLeft color="#000" size={22} onClick={() => onClose(false)} style={{ cursor: "pointer" }} />
          <strong className="text-dark">{appointment.appointment_number}</strong>
          <div>{loggedInUDoctorData && <MdVideocam className="videoIcon" color="#fff" size={36} />}</div>
        </ModalHeader>

        {/* Modal Content */}
        <ModalContent>
          <AccordionHeader onClick={toggleAppointmentExpanded}>
            <span className="text-dark">Appointment Details</span>
            <FaChevronDown color="#000" size={14} />
          </AccordionHeader>
          <AccordionBody isActive={isAppointmentDetailExpanded}>
            {isAppointmentDetailExpanded && (
              <>
                {loggedInUserData ? (
                  <PatientAppointmentRequestCard key={appointment.id} name={appointment.user?.fullname} image={appointment.user?.profile_image} dateOfBirth={appointment.user?.dob} appointmentDate={appointment.date} appointmentTime={appointment.time} gender={appointment.user?.gender} showView={false} />
                ) : (
                  <DoctorDetailHeader image={appointment?.doctor?.image} name={appointment?.doctor?.name} designation={appointment?.doctor?.designation} degrees={appointment?.doctor?.degrees} />
                )}
                <AppointmentTimeInfo date={appointment.date} time={appointment.time} type={appointment.type == 0 ? "Online" : "Clinic"} />
              </>
            )}
          </AccordionBody>
          <div
            style={{
              overflowY: "scroll",
              maxHeight: isDesktop ? "600px" : "calc(100vh - 200px)",
              marginTop: "12px",
            }}
          >
            {messages?.map((msg) => {
              return <ChatMessageItem key={msg.id} isUser={loggedInUserData ?? loggedInUDoctorData} userId={msg.senderUser.userId} msg={msg} onJoinMeetingTap={joinMeeting} />;
            })}
            <div ref={messagesEndRef} />
          </div>
        </ModalContent>

        <div className="bottomItems">
          <div className="messageSendInput">
            <div className="input__Wrapper">
              <input type="text" placeholder="Write here...." value={messageInput} onChange={(e) => setMessageInput(e.target.value)} />
              <IoMdSend color="#fff" className="sendIcon" size={36} onClick={sendTextMessage} />
            </div>
            {/* <CgAttachment color="#fff" className="attachmentIcon ml-2" size={36} /> */}
            <AttachmentMenu onCameraPress={handleCameraPress} onGalleryPress={handleGalleryPress} onRecordPress={handleRecordPress} />
            <input className="d-none" type="file" accept="image/*" ref={imageUploadRef} onChange={(e) => onChooseFile(e, "image")} />
            <input className="d-none" type="file" accept="video/*" ref={videoUploadRef} onChange={(e) => onChooseFile(e, "video")} />
          </div>
        </div>
      </ModalContainer>
    </ModalBackdrop>
  );
};

export default ChatModal;

// Styled Components

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: white;
  width: 100%;
  max-width: 500px;
  height: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  animation: slide-up 0.4s ease-out;

  @media (min-width: 768px) {
    width: 50%;
    height: auto;
    animation: fade-in 0.3s ease-out;
  }

  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .messageSendInput {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 60px;
    width: 100%;
    background-color: #f7f7f7;
    z-index: 1000000;
  }
  .input__Wrapper {
    width: 90%;
    background-color: #ebebeb;
    display: flex;
    align-items: center;
    margin-right: 1rem;
    border-radius: 100px;
  }

  .messageSendInput {
    border-radius: 100px;
    display: flex;
    padding-left: 16px;
    padding-right: 16px;
    align-items: center;
    input {
      border: none;
      outline: none;
      padding: 8px 16px;
      width: 90%;
      background-color: transparent;
      color: #000;
    }

    .sendIcon {
      margin-left: auto;
    }

    .sendIcon,
    .attachmentIcon {
      background: ${linearTopGradient};
      padding: 8px;
      border-radius: 100px;
    }
  }
`;

const ModalHeader = styled.div`
  background: #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #ddd;

  strong {
    font-size: 16px;
    color: #000;
  }

  span {
    font-size: 14px;
    color: #555;
  }
  .videoIcon {
    background: ${linearTopGradient};
    padding: 8px;
    border-radius: 100px;
  }
`;

const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 16px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.3s ease;
  &:hover {
    background: #f1f1f1;
  }
`;

const AccordionBody = styled.div`
  max-height: ${({ isActive }) => (isActive ? "200px" : "0")};
  overflow: hidden;
  transition: max-height 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);

  div {
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    transition: opacity 0.3s ease;
  }
`;

const AttachmentMenu = ({ onCameraPress, onGalleryPress, onRecordPress }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper>
      <ButtonGroup isOpen={isOpen}>
        <SmallButton>
          <MdCameraAlt color="#fff" className="attachmentIcon ml-2" size={40} onClick={onCameraPress} />
        </SmallButton>
        <SmallButton>
          <MdImage color="#fff" className="attachmentIcon ml-2" size={40} onClick={onGalleryPress} />
        </SmallButton>
        <SmallButton>
          <MdVideocam color="#fff" className="attachmentIcon ml-2" size={40} onClick={onRecordPress} />
        </SmallButton>
      </ButtonGroup>

      <MainButton onClick={() => setIsOpen(!isOpen)}>
        <MdAttachFile size={24} color="#fff" />
      </MainButton>
    </Wrapper>
  );
};

// Styled Components
const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonGroup = styled.div`
  position: absolute;
  bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;

  ${({ isOpen }) =>
    isOpen
      ? `
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  `
      : `
    opacity: 0;
    transform: translateY(20px);
    pointer-events: none;
  `}
`;

const SmallButton = styled.button`
  width: 45px;
  height: 45px;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  padding-right: 16;

  &:hover {
    background: ${tuftsBlue};
  }
`;

const MainButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${tuftsBlue};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background: #0056b3;
  }
`;
